import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ENV_IDS, EnvId, EnvironmentName } from "./constants";

export interface EnvironmentState {
  currentEnvironment: EnvironmentName;
  currentEnvId: EnvId;
  isLoading: boolean;
}

const initialState: EnvironmentState = {
  currentEnvironment: 'sandbox', // Default to sandbox for safety
  currentEnvId: ENV_IDS.SANDBOX,
  isLoading: false
};

const environmentSlice = createSlice({
  name: "environment",
  initialState,
  reducers: {
    setEnvironment: (state, action: PayloadAction<{ environment: EnvironmentName, envId: EnvId }>) => {
      state.currentEnvironment = action.payload.environment;
      state.currentEnvId = action.payload.envId;
    },
    setEnvironmentLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    }
  }
});

export const {
  setEnvironment,
  setEnvironmentLoading
} = environmentSlice.actions;

export default environmentSlice.reducer;